{
  "version": 1,
  "palette": { "idle": "#FFE3B0", "active": "#55CCD7", "hit": "#FFF3DC", "award": "#FFC857" },
  "modes": {},
  "cues": {}
}
